<template>
  <div style="margin-bottom: 170px">
    <!-- Tab -->
    <BuTab></BuTab>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group w-702px mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <TableControlShowState v-model="filter.status"></TableControlShowState>
        <button class="btn btn-primary w-88px" @click="getCategories">搜尋</button>
      </div>

      <!-- table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <div v-if="lengthOfisCheckedList > 0"
               class="form-item d-flex align-center px-5 h-60px batch">
            <h5 class="col-checkbox">
              <v-checkbox
                v-model="checkAllStatus"
                :indeterminate="indeterminate"
                @click="changeAllCheckbox"
              ></v-checkbox>
            </h5>
            <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
            <div>
              <button class="btn btn-danger mr-10px" @click="multiDelete">
                <v-icon color="white" class="mr-2">delete</v-icon>
                <span>刪除</span>
              </button>
            </div>
            <div>
              <button class="btn mr-10px" @click="changePublish(true)">設為顯示</button>
            </div>
            <div>
              <button class="btn" @click="changePublish(false)">設為隱藏</button>
            </div>
          </div>
          <tr>
            <th>
              <v-checkbox
                v-model="checkAllStatus"
                :indeterminate="indeterminate"
                @click="changeAllCheckbox"
              ></v-checkbox>
            </th>
            <th class="text-left">Pic</th>
            <th class="text-left">Category Name</th>
            <th class="text-left">BU</th>
            <th class="text-left">Order</th>
            <th class="text-left">ID</th>
            <th class="text-left">顯示/隱藏</th>
            <th class="text-left">編輯</th>
            <th class="text-left">刪除</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in categories"
            :key="item.id"
          >
            <td>
              <v-checkbox v-model="item.isChecked"></v-checkbox>
            </td>
            <td>
              <div
                class="w-40px h-40px bg-cover bg-center"
                :style="{
                  'background-image': `url(${item.image})`,
                }"
              ></div>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.bu.name }}</td>
            <td>{{ item.order }}</td>
            <td>{{ item.id }}</td>
            <td>
              <FormSwitch
                v-model="item.status"
                @changeStatus="changePublish(item.status, item.id)">
              </FormSwitch>
            </td>
            <td>
              <button class="btn square" @click="toCategoryEdit(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </td>
            <td>
              <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- table footer -->
      <Pagination @handleNextPreEvent="getCategories" model="category"></Pagination>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import BuTab from '@/components/BuTab.vue';

import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    TableControlShowState,
    FormSwitch,
    deleteDialog,
    Pagination,
    BuTab,
  },
  data: () => ({
    checkAllStatus: false, // left top checkbox status
  }),
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('category', ['categories', 'filter']),
    lengthOfisCheckedList() {
      return this.categories.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.categories.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.categories.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.categories.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.categories.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.categories.length) {
        this.checkAllStatus = true;
      }
      if (this.categories.length === 0) {
        this.checkAllStatus = false;
      }
    },
    currentBuTabId(newValue) {
      this.filter.buId = newValue;
      this.getCategories();
    },
  },
  methods: {
    ...mapActions('category', {
      getCategories: 'find',
      destroyCategory: 'destroy',
      publish: 'publish',
      clear: 'clear',
    }),
    toCategoryEdit(id) {
      this.$router.push({ name: 'CategoryInfoEdit', params: { id } });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.categories.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.categories.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyCategory(id).then(() => {
        this.getCategories();
      });
    },
    async changePublish(status, id) {
      this.checkAllStatus = false;
      await this.publish({
        ids: id ? [id] : this.isCheckedListIds,
        status,
      }).then(() => {
        this.getCategories();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyCategory(id).then(() => {});
      });
      this.getCategories();
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-pic {
    width: 40px;
    margin-right: 20px;
  }
  .col-category-name {
    min-width: 100px;
    margin-right: 45px;
  }
  .col-bu {
    min-width: 65px;
    margin-right: 38px;
  }
  .col-order {
    width: 80px;
    margin-right: 40px;
    text-align: right;
  }
  .col-id {
    width: 80px;
    text-align: right;
  }
  .col-show {
    margin-right: 40px;
  }
}
</style>
